export const nbsp = '\u00A0';

export const EMPTY_ARRAY = [];

export const EMPTY_OBJECT = {};
